export default __webpack_public_path__ + "static/media/va2021.e27d274b.jpg";